import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';

@Component({
  selector: 'page-demopage',
  templateUrl: 'demopage.html'
})
export class DemopagePage {
  // this tells the tabs component which Pages
  // should be each tab's root Page
  constructor(public navCtrl: NavController) {
  }
  
}



// WEBPACK FOOTER //
// ./src/pages/demopage/demopage.ts